module.exports = __webpack_public_path__ + "media/images/benefit_logo-b5744b93e4b4438d38bb2cdae2eae576.png";